import { useQuery } from "@tanstack/react-query";

import type {
    IDeviceTotalVisitsResponseData,
    IWebsiteAnalysisTrafficRequestParams,
} from "app/pages/website-analysis/TrafficAndEngagement/types";
import WebsiteAnalysisApiService from "app/services/WebsiteAnalysis/WebsitAnalysisApiService";

interface ICompareTotalVisitsOptions {
    controller?: string;
    enabled?: boolean;
}

export const useCompareTotalVisitsData = (
    params: IWebsiteAnalysisTrafficRequestParams,
    { controller, enabled = true }: ICompareTotalVisitsOptions = {},
) => {
    return useQuery<IDeviceTotalVisitsResponseData>({
        queryKey: ["totalVisitsCompare", params, controller],
        queryFn: () =>
            WebsiteAnalysisApiService.getInstance().getSingleCompareTotalVisitsData(params, controller),
        enabled,
    });
};
